module.exports = __webpack_public_path__ + "img/Michelle_Lakisa.4af256bb.jpg";